import { useState } from "react";
import { CalendarDays, ChevronLeft, ChevronRight } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

const MONTHS = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];
const FULL = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];
const thisMonth = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`; };

// pt-BR month/year picker (value "AAAA-MM" or "").
export function MonthPicker({ value = "", onChange, testid, className = "mt-1 h-9 w-44", clearable = true, placeholder = "Selecione o mês" }) {
  const [open, setOpen] = useState(false);
  const baseYear = () => Number((value || thisMonth()).slice(0, 4));
  const [year, setYear] = useState(baseYear);
  const pick = (v) => { onChange(v); setOpen(false); };
  const btn = "rounded-md px-2 py-1.5 text-sm transition-colors";
  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (o) setYear(baseYear()); }}>
      <PopoverTrigger asChild>
        <button type="button" className={`flex min-w-0 items-center justify-between gap-2 rounded-md border border-input bg-white px-3 text-sm text-slate-900 ${className}`} data-testid={testid}>
          {value ? <span className="truncate">{`${FULL[Number(value.slice(5)) - 1]} de ${value.slice(0, 4)}`}</span> : <span className="truncate text-slate-400">{placeholder}</span>}<CalendarDays className="h-4 w-4 shrink-0 text-slate-500" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" collisionPadding={12} className="w-64 p-3" data-testid={`${testid}-popover`}>
        <div className="mb-2 flex items-center justify-between">
          <button type="button" onClick={() => setYear(year - 1)} className="rounded p-1 hover:bg-slate-100" data-testid={`${testid}-prev-year`}><ChevronLeft className="h-4 w-4" /></button>
          <span className="text-sm font-semibold" data-testid={`${testid}-year`}>{year}</span>
          <button type="button" onClick={() => setYear(year + 1)} className="rounded p-1 hover:bg-slate-100" data-testid={`${testid}-next-year`}><ChevronRight className="h-4 w-4" /></button>
        </div>
        <div className="grid grid-cols-4 gap-1">
          {MONTHS.map((m, i) => { const v = `${year}-${String(i + 1).padStart(2, "0")}`; return (
            <button key={m} type="button" onClick={() => pick(v)} className={`${btn} ${v === value ? "bg-[#0B6FC2] text-white" : "hover:bg-slate-100"}`} data-testid={`${testid}-m-${i + 1}`}>{m}</button>); })}
        </div>
        <div className="mt-2 flex justify-between border-t pt-2">
          {clearable ? <button type="button" onClick={() => pick("")} className={`${btn} text-sky-700 hover:bg-slate-100`} data-testid={`${testid}-clear`}>Limpar</button> : <span />}
          <button type="button" onClick={() => pick(thisMonth())} className={`${btn} text-sky-700 hover:bg-slate-100`} data-testid={`${testid}-today`}>Este mês</button>
        </div>
      </PopoverContent>
    </Popover>);
}
